import { useCallback } from 'react';
import { useActions } from './useActions';

/**
 * @returns {(switch_to: 'inbox'|'next', options: { redirectTo: string })=> Promise<void>} Switch handler
 */
export function useSwitchApp() {
    const { api } = useActions();

    return useCallback(
        async (switchTo, options) => {
            const { redirect_to } = await api.users.switchApp({ payload: { app: switchTo, ...options } });

            if (redirect_to) {
                window.location.href = redirect_to;
            }
        },
        [api]
    );
}
